import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  close1s6qtnweux4fu as close,
  ObjectPool3iks1t8z0qq3m as ObjectPool,
} from './Pool.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultPoolClass;
function DefaultPool() {
  if (DefaultPoolClass === VOID) {
    class $ {
      constructor(capacity) {
        this.m4p_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.m4p_1;
        tmp.n4p_1 = Array(size);
        this.o4p_1 = 0;
      }
      p4p(instance) {
      }
      q4p(instance) {
        return instance;
      }
      r4p(instance) {
      }
      s4p() {
        if (this.o4p_1 === 0)
          return this.l4p();
        this.o4p_1 = this.o4p_1 - 1 | 0;
        var idx = this.o4p_1;
        var tmp = this.n4p_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.n4p_1[idx] = null;
        return this.q4p(instance);
      }
      t4p(instance) {
        this.r4p(instance);
        if (this.o4p_1 === this.m4p_1) {
          this.p4p(instance);
        } else {
          var _unary__edvuaz = this.o4p_1;
          this.o4p_1 = _unary__edvuaz + 1 | 0;
          this.n4p_1[_unary__edvuaz] = instance;
        }
      }
      n10() {
        var inductionVariable = 0;
        var last = this.o4p_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.n4p_1[i];
            var instance = !(tmp == null) ? tmp : THROW_CCE();
            this.n4p_1[i] = null;
            this.p4p(instance);
          }
           while (inductionVariable < last);
        this.o4p_1 = 0;
      }
    }
    protoOf($).m6 = close;
    initMetadataForClass($, 'DefaultPool', VOID, VOID, [ObjectPool()]);
    DefaultPoolClass = $;
  }
  return DefaultPoolClass;
}
//region block: exports
export {
  DefaultPool as DefaultPool2gb1fm4epwgu9,
};
//endregion

//# sourceMappingURL=DefaultPool.mjs.map
